import * as types from '../../actionTypes'

export const clearUsers = () => {
  return {
    type: types.CLEAR_USERS,
  }
}

export const fetchingProductUser = () => ({
  type: types.FETCHING_PRODUCT_USER,
})

export const fetchingProductUserError = () => {
  return {
    type: types.FETCHING_PRODUCT_USER_ERROR,
    error: 'Error fetching Product User',
  }
}

export const fetchingNetsuiteCustomer = () => ({
  type: types.FETCHING_NETSUITE_CUSTOMER,
})
export const fetchingNetsuiteCustomerSuccess = netsuiteCustomer => ({
  type: types.FETCHING_NETSUITE_CUSTOMER_SUCCESS,
  netsuiteCustomer,
})
export const fetchingNetsuiteCustomerError = error => ({
  type: types.FETCHING_NETSUITE_CUSTOMER_ERROR,
  error,
})

export const fetchingProductUserSuccess = productUser => {
  return {
    type: types.FETCHING_PRODUCT_USER_SUCCESS,
    productUser,
  }
}

export const fetchingSetupAdminUserId = () => ({
  type: types.FETCHING_SETUP_ADMIN_USER_ID,
})

export const fetchingSetupAdminUserIdError = (
  error = 'Error fetching Setup Admin User',
) => {
  return {
    type: types.FETCHING_SETUP_ADMIN_USER_ID_ERROR,
    error,
  }
}

export const fetchingSetupAdminUserIdSuccess = id => {
  return {
    type: types.FETCHING_SETUP_ADMIN_USER_ID_SUCCESS,
    setupAdminUserId: id,
  }
}

export const savingProductUser = () => ({
  type: types.SAVING_PRODUCT_USER,
})

export const savingProductUserError = () => {
  return {
    type: types.SAVING_PRODUCT_USER_ERROR,
    error: 'Error saving Product User',
  }
}

export const savingProductUserSuccess = productUser => {
  return {
    type: types.SAVING_PRODUCT_USER_SUCCESS,
    productUser,
  }
}

export const savingProductUserPakSuccess = () => {
  return {
    type: types.SAVING_PRODUCT_USER_PAK_SUCCESS,
  }
}

export const fetchingLessonProgressReport = () => ({
  type: types.FETCHING_LESSON_PROGRESS_REPORT,
})
export const fetchingLessonProgressReportSuccess = sasUrl => ({
  type: types.FETCHING_LESSON_PROGRESS_REPORT_SUCCESS,
  sasUrl,
})
export const fetchingLessonProgressReportError = error => ({
  type: types.FETCHING_LESSON_PROGRESS_REPORT_ERROR,
  error,
})

export const fetchingArchetypes = () => ({
  type: types.FETCHING_ARCHETYPES,
})
export const fetchingArchetypesSuccess = archetypes => ({
  type: types.FETCHING_ARCHETYPES_SUCCESS,
  archetypes,
})
export const fetchingArchetypesError = error => ({
  type: types.FETCHING_ARCHETYPES_ERROR,
  error,
})



// WEBPACK FOOTER //
// ./src/redux/css-admin/userManager/actions.js